// extracted by mini-css-extract-plugin
export default {"container":"PersonalDataSecurityPolicyPage_container__vWi58"};